export const cloudinaryService = {
  uploadToCloudinary: async (file, type) => {
    const formData = new FormData();
    formData.append('file', file);
    
    // Sélection du preset en fonction du type de document
    const uploadPreset = type === 'cv' 
      ? process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET_CV
      : process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET_LM;
    
    formData.append('upload_preset', uploadPreset);
    formData.append('resource_type', 'auto');

    try {
      const response = await fetch(
        `https://api.cloudinary.com/v1_1/${process.env.REACT_APP_CLOUDINARY_CLOUD_NAME}/upload`,
        {
          method: 'POST',
          body: formData
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        console.error('Erreur Cloudinary:', errorData);
        throw new Error(`Erreur Cloudinary: ${errorData.error?.message || 'Upload failed'}`);
      }

      const data = await response.json();
      
      // Construction de l'URL optimisée
      const optimizedUrl = `https://res.cloudinary.com/${process.env.REACT_APP_CLOUDINARY_CLOUD_NAME}/image/upload/f_auto,q_auto/${data.public_id}`;
      
      return optimizedUrl;
    } catch (error) {
      console.error('Erreur détaillée:', error);
      throw new Error('Erreur lors de l\'upload sur Cloudinary');
    }
  },
}; 